import { ActionReducerMap } from '@ngrx/store';
import { BrandsByApplianceState } from '@sky/util-models';

import {
  appliancesReducer,
  AppliancesState,
  APPLIANCES_KEY,
} from './appliances/appliances.reducer';
import { brandsReducer, BRANDS_KEY } from './brands/brands.reducer';

export const CATALOG_FEATURE_KEY = 'catalog';

export interface CatalogState {
  [APPLIANCES_KEY]: AppliancesState;
  [BRANDS_KEY]: BrandsByApplianceState;
}

export interface CatalogPartialState {
  [CATALOG_FEATURE_KEY]: CatalogState;
}

export const catalogReducer: ActionReducerMap<CatalogState> = {
  [APPLIANCES_KEY]: appliancesReducer,
  [BRANDS_KEY]: brandsReducer,
};
